import { IsUUID, Matches, IsOptional, Length } from "class-validator"
import { numberRegExp } from "../constant"

export class Param {
  @IsUUID()
  asset_id: string

  @IsUUID()
  user_id: string

  address: string

  @Matches(numberRegExp, {
    message: ({ property }) => `${property} must be a number string`,
  })
  @IsOptional()
  amount?: string

  @IsOptional()
  full_name?: string

  @IsUUID()
  @IsOptional()
  trace?: string

  @Length(1, 139)
  @IsOptional()
  memo?: string
}
